import { SurprisePerkType } from 'models';

interface SurprisePerkContent {
  title: string;
  subtitle?: string;
  text: string;
  subtext?: string;
  callToAction?: string;
}

export const content: Record<SurprisePerkType, SurprisePerkContent> = {
  surprise: {
    title: 'Congratulations!',
    subtitle: 'Your Surprise Perk awaits!',
    text: `You've bagged yourself a Surprise Perk.`,
    subtext: `Click below to find out what tasty treat awaits you.`,
    callToAction: 'See My Surprise Perk',
  },
  'spin-to-win': {
    title: 'Spin the Wheel to reveal your free perk!',
    text: 'Find out what tasty treat awaits you...',
    callToAction: 'Spin the Wheel!',
  },
};
